import {
  Component,
  HostListener,
  inject,
  Injector,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router, RouterModule} from '@angular/router';
import {WmsFeatureDirective} from '@wms/directives';
import {BaseComponent} from "../base/base.component";
import {BsDropdownDirective, BsDropdownModule} from "ngx-bootstrap/dropdown";
import {WmsDialogComponent} from '../wms-dialog/wms-dialog.component';
import {WmsDialogHeaderComponent} from '../wms-dialog-header/wms-dialog-header.component';
import {WmsDialogBodyComponent} from '../wms-dialog-body/wms-dialog-body.component';
import {WmsDialogFooterComponent} from '../wms-dialog-footer/wms-dialog-footer.component';
import {
  DialogService,
  NotificationService,
  PageService,
  PreviewService,
  SpinnerService,
  StudioFactory,
  StudioService,
  UserService,
  WmHttpService
} from '@wms/services';
import {handleInvalidRepoBranch, PROJECT_ID_PARAM_NAME, StudioUtils, VersionManagerPipe} from "@wms/core";
import {WmsRecentWsListComponent} from "@wms/app/components/wms-recent-ws-list/wms-recent-ws-list.component";
import {LocaleDialogComponent} from '@wms/i18n';
import {WmsVcsMenuItemComponent} from '@wms/app/vcs/components/wms-vcs-menu-item/wms-vcs-menu-item.component';
import {WmsVcsDialogComponent} from '@wms/app/vcs/components/wms-vcs-dialog/wms-vcs-dialog.component';
import {VcsService} from '@wms/app/vcs/services/vcs.service';
import {StudioUserInfoComponent} from "@wms/app/studio-user-info/studio-user-info.component";
import {PrefabPublishService, PublishToTeamComponent, PublishToWorkspaceComponent} from "@wms/prefab-publish";
import {
  WmsVcsUserCredentialsComponent
} from "@wms/app/vcs/components/wms-vcs-dialog/wms-vcs-user-credentials/wms-vcs-user-credentials.component";
import {FormsModule} from "@angular/forms";
import {ExportMenuComponent} from "@wms/app/artifact-export/components/export-menu/export-menu.component";
import {DeploymentService} from '@wms/app/deployment/deployment.service';
import {DeployDialogComponent} from '@wms/app/deployment/wms-deploy-dialog/deploy-dialog/deploy-dialog.component';
import {
  WmsPushChangesDialogComponent
} from '@wms/app/deployment/wms-deploy-dialog/wms-push-changes-dialog/wms-push-changes-dialog.component'
import {PageWsService, WmsWorkspaceManagerService} from "@wms/workspace";
import {VcsAPIService} from "@wms/app/vcs/services/vcs-api/vcs-api.service";
import {PrefabPublishComponent} from "../../prefab-publish/prefab-publish.component";
import {PublishToProjectComponent} from "../../prefab-publish/publish-to-project/publish-to-project.component";
import {cloneDeep, filter, forEach, includes, isEmpty, isUndefined, sortBy} from "lodash-es";
import {environment, WmCommandProvider} from "@wms/app";
import {
  WmsVcsProjectChangesDialogComponent
} from "@wms/app/vcs/components/wms-vcs-dialog/wms-vcs-project-changes-dialog/wms-vcs-project-changes-dialog.component";
import {
  ProjectUpdatesNotificationComponent
} from "@wms/app/project-updates/components/project-updates-notification/project-updates-notification.component";
import {
  ProjectUpdatesListComponent
} from "@wms/app/project-updates/components/project-updates-list/project-updates-list.component";
import {ProjectUpdatesService} from "@wms/app/project-updates/services/project-updates/project-updates.service";
import {
  PrefabConfictDialogComponent
} from '@wms/app/vcs/components/wms-vcs-dialog/prefab-confict-dialog/prefab-confict-dialog.component';
import {
  WmsUnsavedChangesDialogComponent
} from "@wms/app/wms-unsaved-changes-dialog/wms-unsaved-changes-dialog.component";
import {
  SourceCodeUpdatesComponent
} from "@wms/app/project-updates/components/source-code-updates-dialog/source-code-updates.component";
import {EditInWmInfoComponent} from "@wms/app/edit-in-wm-info/edit-in-wm-info.component";

import {SearchComponent, WmsSpinnerComponent} from '@wms/components';
import {OrderByPipe} from '@wm/components-base';
import {BaseVariableService} from "@wms/variables";
import {TabsModule} from "ngx-bootstrap/tabs";
import {JobStatusService} from "@wms/app/jobs/service/job-status.service";
import {JavaService} from "@wms/app/workspace/java-service-workspace/services/java/java.service";
import {MiddleEllipsisPipe} from "@wms/app/middle-ellipsis.pipe";

const routes = [
  {path: '/page',header:'PAGE'},
  { path: '/database', header: 'DB' },
  { path: '/settings', header: 'SETTINGS' },
  { path: '/java-service', header: 'JAVASERVICE' },
  { path: '/apis', header: 'APIDESIGNER' },
  { path: '/files', header: 'FILES' }
];

@Component({
    selector: 'wms-header',
    standalone: true,
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.less'],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    WmsFeatureDirective,
    BsDropdownModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    LocaleDialogComponent,
    VersionManagerPipe,
    WmsVcsMenuItemComponent,
    WmsVcsDialogComponent,
    StudioUserInfoComponent,
    WmsVcsUserCredentialsComponent,
    ExportMenuComponent,
    WmsRecentWsListComponent,
    DeployDialogComponent,
    WmsPushChangesDialogComponent,
    PrefabPublishComponent,
    PublishToProjectComponent,
    PublishToTeamComponent,
    PublishToWorkspaceComponent,
    WmsVcsProjectChangesDialogComponent,
    ProjectUpdatesNotificationComponent,
    ProjectUpdatesListComponent,
    PrefabConfictDialogComponent,
    WmsUnsavedChangesDialogComponent,
    SourceCodeUpdatesComponent,
    EditInWmInfoComponent,
    SearchComponent,
    WmsSpinnerComponent,
    OrderByPipe,
    TabsModule,
    LocaleDialogComponent,
    MiddleEllipsisPipe
  ],
  providers: [
    BsDropdownDirective
    ]
})
export class HeaderComponent extends BaseComponent implements OnInit, OnDestroy {
  private dialogService: DialogService;
  private pageService: PageService;
  private router: Router;
  protected previewService: PreviewService;
  protected projectDetails: any;
  protected projectEdnDetails: any;
  protected isApplicationType: boolean;
  protected versionManager: VersionManagerPipe = inject(VersionManagerPipe);
  protected projectAvatarPath: string = this.versionManager.transform('assets/images/provatars/');
  protected userService: UserService;
  public studioFactory: StudioFactory;
  public vcsService: VcsService
  public isPrefabType: boolean;
  public deploymentService: DeploymentService
  public vcsApiService: VcsAPIService;
  public artifactType:  any;
  public user: any;
  public wsManager: WmsWorkspaceManagerService;
  public projectUpdatesService: ProjectUpdatesService;
  activeWS: any;
  wmCommand: WmCommandProvider;
  notificationService: NotificationService;
  studioService: StudioService;
  wmHttpService: WmHttpService;
  spinnerService: SpinnerService;
  projectParams: any;
  switchToProject: any;
  showBranchesContainer = false;
  isAiraMode: boolean = false;
  isProjectSwitchDialogClosed = true;
  PROJECTS_LIST_MAX_COUNT = 5;
  projectsMap: { [key: string]: any; } = {};
  projectsVisibleCount = this.PROJECTS_LIST_MAX_COUNT;
  projectActivityLoading: boolean;
  projectName: string;
  filteredBranches: any;
  selectedOrganization: any;
  isNativeMobileApplicationType: boolean = false;

  variableService:BaseVariableService;
  pageWsService:PageWsService;
  javaApiService:JavaService;
  @ViewChild('dropdown', { static: false }) dropdown: BsDropdownDirective;
  @ViewChild('dropdownExport', { static: false }) dropdownExport: BsDropdownDirective;
  @ViewChild('dropdownProjectUpdates', { static: false }) dropdownProjectUpdates: BsDropdownDirective;
  isWSSwitchBlocked:boolean;
  @ViewChild('sample', { static: false }) sampleRef?: TemplateRef<any>; //TODO: to be removed
  protected exportMenu: ExportMenuComponent;
  isProjectUpdatesDropdownOpen = false;
  jobstatusService:JobStatusService;
  @ViewChild('dynamicLeftHeader', { read: ViewContainerRef })
  dynamicLeftHeader!: ViewContainerRef;
  @ViewChild('dynamicRightHeader', { read: ViewContainerRef })
  dynamicRightHeader!: ViewContainerRef;
  constructor(  public prefabPublishService: PrefabPublishService , private injector: Injector) {
    super();

    this.spinnerService = inject(SpinnerService);
    this.dialogService = inject(DialogService);
    this.pageService = inject(PageService);
    this.router = inject(Router);
    this.previewService = inject(PreviewService);
    this.studioFactory = inject(StudioFactory);
    this.projectDetails = this.projectService.getDetails();
    this.projectEdnDetails = this.projectService.getProjectEdnDetails();
    this.isApplicationType = this.projectService.isApplicationType();
    this.vcsService = inject(VcsService);
    this.isPrefabType   = this.projectService.isPrefabType();
    this.vcsApiService = inject(VcsAPIService);
    this.deploymentService = inject(DeploymentService);
    this.userService = inject(UserService);
    this.user = this.userService.get();
    this.projectUpdatesService = inject(ProjectUpdatesService);
    this.wsManager = inject(WmsWorkspaceManagerService);
    this.wmCommand = inject(WmCommandProvider);
    this.notificationService = inject(NotificationService);
    this.studioService = inject(StudioService)
    this.wmHttpService = inject(WmHttpService);
    this.isNativeMobileApplicationType = this.projectService.isNativeMobileApplicationType();
    this.variableService = inject(BaseVariableService);
    this.pageWsService = inject(PageWsService);
    this.jobstatusService = inject(JobStatusService);
    this.javaApiService = inject(JavaService);

    this.eventManager.keyboardActionObservable().subscribe((data: any) => {
      this.performAction(data.key, data.event);
    })


    this.eventManager.onRouterChange().subscribe((data: any) => {
      const matchedRoute = routes.find(route => data.startsWith(route.path));
      if (matchedRoute  && data.endsWith(this.projectDetails.id)) {
        if(matchedRoute.header === 'PAGE' && isEmpty(this.pageWsService.pageSubCategory)){
          this.pageWsService.pageSubCategory = 'LIST';
        }
        this.loadHeaderForRoute(matchedRoute.header);
      }else{
        this.dynamicLeftHeader.clear();
        this.dynamicRightHeader?.clear();
      }
    });

  }

  ngOnInit(): void {
    this.deploymentService.getSetupInfo()
    this.studioService.getSelectedOrganization().then((res: any) => {
      this.selectedOrganization = res;
    });
    this.eventManager.notifySwitchAiStudioObservable().subscribe((data: any) => {
      this.isAiraMode = data;
    });

  }

  private async loadHeaderForRoute(url: string) {
    // Clear all containers
    if (this.dynamicLeftHeader) {
      this.dynamicLeftHeader.clear();
    }
    if (this.dynamicRightHeader) {
      this.dynamicRightHeader.clear();
    }

    const componentMap: any = {
      'DB': {
        left: () => import('@wms/app/db-header/db-header.component')
          .then(c => c.DbHeaderComponent),
        right: () => import('@wms/app/db-right-header/db-right-header.component')
          .then(c => c.DbRightHeaderComponent)
      },
      'SETTINGS': {
        left: () => import('@wms/app/setting-header/setting-header.component')
          .then(c => c.SettingHeaderComponent),
        right: null
      },
      'JAVASERVICE': {
        left:()=>import('@wms/app/java-service-left-header/java-service-left-header.component').then(c => c.JavaServiceLeftHeaderComponent),
        right:  () => import('@wms/app/java-service-header/java-service-header.component')
      .then(c => c.JavaServiceHeaderComponent),// No right component for this route
      },
      'APIDESIGNER': {
        left:() => import('@wms/app/api-left-header/api-left-header.component')
          .then(c => c.ApiLeftHeaderComponent),
        right:  () => import('@wms/app/api-right-header/api-right-header.component')
          .then(c => c.ApiRightHeaderComponent),
      },
      'FILES': {
        left:() => import('@wms/app/files-left-header/files-left-header.component')
          .then(c => c.FilesLeftHeaderComponent),
        right:  () => import('@wms/app/files-right-header/files-right-header.component')
          .then(c => c.FilesRightHeaderComponent),
      }
    };

    const matchedRoute: any = Object.keys(componentMap).find(path => url.includes(path));

    if (matchedRoute) {
      const routeConfig = componentMap[matchedRoute];

      try {
        // Load left component
        if (routeConfig.left) {
          const leftComponentLoader = routeConfig.left;
          const leftComponent = await leftComponentLoader();
          if (this.dynamicLeftHeader) {
            this.dynamicLeftHeader.clear();
            this.dynamicLeftHeader.createComponent(leftComponent, {
              injector: this.injector
            });
          }
        }

        // Load right component
        if (routeConfig.right) {
          const rightComponentLoader = routeConfig.right;
          const rightComponent = await rightComponentLoader();
          if (this.dynamicRightHeader) {
            this.dynamicRightHeader.clear();
            this.dynamicRightHeader.createComponent(rightComponent, {
              injector: this.injector
            });
          }
        }
      } catch (error) {
        console.error(`Failed to load components for ${matchedRoute}:`, error);
      }
    }
  }



  getLoadedPageName() {
    return this.pageService.getActivePageName()
  }
  isActiveWSDirty() {
    if (this.wsManager.activeWS.type === 'PAGE' || this.wsManager.activeWS._category === 'RESOURCE' || this.wsManager.activeWS._category === 'JAVASERVICE') {
      return this.wsManager.isWSDirty();
    }
    return false
  }

  performAction(action: string, event: Event) {
    /*By registering this event we are overriding browser's default save event (Ctrl+S).
            * So whenever user press Ctrl+S in studio mode app will try to save currently active workspace.*/
    if ("SAVE" === action) {
      event.stopPropagation();
      event.preventDefault();
      this.wsManager.triggerSaveImmediately = true;
      this.wsManager.keyEvent = true;
      if(this.wsManager.activeWSCategory === "PAGE"){
        this.pageWsService.startAutoSave(true);
      }else{
        this.wsManager.saveActiveWs.next(() => {});
      }
    } else if (includes(["RUN", "RUN-DEBUG"], action)) {
      event.stopPropagation();
      event.preventDefault();
      // TODO: check this flag
      // if (!$rootScope.isStudioDisabled) {
        this.previewService.previewApp(action);
      // }
    } else if ("PREVIEW" === action) {
      event.stopPropagation();
      event.preventDefault();
      // TODO: check this flag
      // if (!$rootScope.isStudioDisabled) {
        this.previewService.previewPage(this.getLoadedPageName(), action);
      // }
    } else if ("DEPLOY" === action && this.preferences['project.actions.build.deploy']) {
      if (handleInvalidRepoBranch()) return;
      event.stopPropagation();
      event.preventDefault();
      if (!$("div[dialogId=deployDialog]").is(':visible')) {
        /*If deployment target is available, deploy using that pipelinePhaseId or configure test phase first*/
        this.deployToCloud();
      }
    }
  }

  deployToCloud() {
    if (handleInvalidRepoBranch()) return;
    this.deploymentService.deployToCloud()
  }

  reDeployToCloud() {
    if (handleInvalidRepoBranch()) return;
    this.deploymentService.reDeployToCloud()
  }

  showDeployStatus() {
    this.deploymentService.checkDeployStatus()
  }
  openDialogWithId(id: string): void {
    this.dialogService.open(id)
  }
  closeDialogWithId(id: string): void {
    this.dialogService.close(id)
  }

  isPagePreviewAvailable() {
    const activePageName = this.pageService.getActivePageName();

    // return true if
    // - project is application type
    // - activePageName is not null
    // - activePage is of 'PAGE' type
    // - activePageName is not homePage, in this case app preview should be done and not page preview
    return (this.projectService.isApplicationType() &&
      activePageName && this.projectService.getPageInfo(activePageName).type === 'PAGE' &&
      activePageName !== this.projectService.getHomePage());
  };

  runProject(): void {
    this.wsManager.triggerSaveImmediately = true;
    this.wsManager.saveActiveWs.next(() => {
      // if page preview is available, then preview page, else preview app
      if (this.isPagePreviewAvailable()) {
        this.previewService.previewPage(this.getLoadedPageName(), 'PREVIEW'); // pass active page name later
      } else {
        this.previewService.previewApp();
      }
    });
  }

  manageAppMessages(): void {
    this.dialogService.open("appMessagesDialog",{activeTab: 0});
  }

  mergeConflicts(): void { console.log('clicked on mergeConflicts!') }
  addProjectToExternalVCS(): void { console.log('clicked on addProjectToExternalVCS!') }


  configProfiles(): void { console.log('clicked on configProfiles!') }
  configProjectSettings(): void { console.log('clicked on configProjectSettings!') }
  configAccessControl(): void { console.log('clicked on configAccessControl!') }

  publishPrefabToProject() {

  }

  closeProject(params?: any) {
    this.projectParams = params;

    if(this.wsManager.activeWSCategory === 'PAGE'  && this.pageWsService.isDirty()){
        this.dialogService.open('unsavedChangesDialog_browser');
    }else{
      this.saveAndClose();
    }

  }


  confirmDialogAction(result: any) {
    if (result) {
      this.confirmActionOk();
    } else {
      this.confirmActionCancel();
    }

  }

  confirmActionOk() {
    //bypass the beforeunload event as the dialog is already shown
    this.wsManager.byPassUnLoadCheck = true;
    this.dialogService.close('unsavedChangesDialog_browser');
    this.saveAndClose();
  }


  confirmActionCancel() {
    this.dialogService.close('unsavedChangesDialog_browser');
    this.wsManager.byPassUnLoadCheck = true;
    this.logoutAndExit(this.projectParams)
  }


  cleanProject(projectId: any) {
    let proj = this.projectService.getDetails()
    this.projectService.clean(projectId).then(() => {
      if (isUndefined(this.switchToProject)) {
        /*go to index.html - projects page*/
        //To persist the tab send project type to open specific tab on project list page.
        window.location.href = '/projects/';
      } else {
        // switch to that project
        window.location.href = 'page?'+ PROJECT_ID_PARAM_NAME +'=' + this.switchToProject.studioProjectId;
      }
    })
  };


  logoutProject() {
    this.userService.logout().then(() => {
      this.wmCommand.reset();
      if (this.preferences.hasAccess('workspace.redirectToCloudLoginPage')) {
        window.location.href = "/login/signout";
      } else {
        StudioUtils.redirectToLoginPage();
      }
    })
  };
  saveAndClose() {
    this.wsManager.triggerSaveImmediately = true;
    this.wsManager.saveActiveWs.next(() => {
      this.logoutAndExit(this.projectParams);
    });
  }


  logoutAndExit(pramas:any){
    if (pramas && pramas.isLogout) {
      this.logoutProject();
    } else {
      this.cleanProject(this.projectService.getProjectId())
    }
  }

  assignReference($event: any) {
    this.exportMenu = $event;
  }

  publishProjectAsCore(){
    if (handleInvalidRepoBranch()) return;

    this.wsManager.triggerSaveImmediately = true;
    this.wsManager.saveActiveWs.next(() => {
      if(this.projectService.teamProjectObject.vcsAccountDTO.mrFlowEnabled) {
        this.vcsApiService.validateNoChanges().then(() => {
          this.exportMenu.artifactType = 'PROJECTCORE';
          this.exportMenu.openPublishToTeamDialog();
        }, (error) => {
          if(error && error.status === 400 && error.error.errors.error[0].messageKey === "com.wavemaker.vcs$haveUnPushedChanges") {
            this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], this.locale.MSG_ERROR_UNPUSHED_CHANGES);
          }
          if(error && error.status === 400 && error.error.errors.error[0].messageKey === "com.wavemaker.vcs$unMergedChanges") {
            this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], this.locale.MSG_ERROR_UNMERGED_CHANGES);
          }
        });
      } else {
        this.vcsService.publishProjectAsCore = true;
        this.vcsService.openPushProjectDialog(()=> {
          this.vcsService.publishProjectAsCore = false
          this.exportMenu.artifactType = 'PROJECTCORE';
          this.exportMenu.openPublishToTeamDialog();
        });
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.dropdown.isOpen) {
      this.dropdown.isOpen = false;
    }
    if (event.key === 'Escape' && this.dropdownExport.isOpen) {
      this.dropdownExport.isOpen = false;
    }

  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (this.dropdownProjectUpdates.isOpen && !target.closest('.dropdownProjectUpdates')) {
      this.dropdownProjectUpdates.isOpen = false;
    }
  }

  getProjectList() {
    this.projectService.getProjectDetails("", false).then((list) => {
      this.projectsMap = {};
      this.projectName = this.projectEdnDetails.name;

      forEach(sortBy(list, 'lastAccessedDate').reverse(), (proj) => {
        if (proj.projectType === this.projectDetails.type) {
          if (proj.projectType !== 'APPLICATION') {
            proj.displayProjType = proj.projectType;
          } else {
            if (proj.platformType === 'NATIVE_MOBILE') {
              proj.displayProjType = 'NATIVE MOBILE';
            } else if (proj.platformType === 'WEB') {
              proj.displayProjType = 'WEB';
            } else {
              proj.displayProjType = 'MOBILE';
            }
          }
          if (!this.projectsMap[proj.name]) {
            this.projectsMap[proj.name] = [];
          }
          if (this.projectsMap[proj.name].length === 0) {
            this.projectsMap[proj.name] = filter(list, { name: proj.name });
          }
        }
      });
      this.filteredBranches = this.projectsMap[this.projectName];
      this.projectActivityLoading = false;
    }, (errMsg) => {
      this.projectActivityLoading = false;
      this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, errMsg);
    });
  }

  toggleProjectsList() {
    if (this.preferences?.project?.branch?.switch) {
      this.showBranchesContainer = this.isProjectSwitchDialogClosed;
      this.isProjectSwitchDialogClosed = !this.isProjectSwitchDialogClosed;
      this.projectName = this.projectEdnDetails.name;
      this.projectsVisibleCount = this.PROJECTS_LIST_MAX_COUNT;

      if (this.showBranchesContainer) {
        this.projectActivityLoading = true;
        this.getProjectList();
        setTimeout(() => {
          $("#project-branch-container").trigger('focus')

          $("#project-branch-container").on('focusout', (event) => {
            const $relatedTarget = $(event.relatedTarget as EventTarget);
            if ($relatedTarget.closest('#project-branch-container').length === 0) {
              this.closeProjectSwitchDialog();
            }
          });
        }, 0);
      }
    }
  };

  closeProjectSwitchDialog() {
    this.showBranchesContainer = false;
    this.isProjectSwitchDialogClosed = true;
  };

  onBranchSearch({ searchKey }: { searchKey: string }) {
    if (isEmpty(searchKey)) {
      this.filteredBranches = cloneDeep(this.projectsMap[this.projectName]);
      this.projectsVisibleCount = this.PROJECTS_LIST_MAX_COUNT;
    } else {
      this.filteredBranches = filter(this.projectsMap[this.projectName], function (proj) {
        return proj.vcsBranch.match(new window.RegExp(searchKey, 'i'));
      });
    }
  };

  switchProject(project: any) {
    if (project.studioProjectId !== this.projectEdnDetails.studioProjectId) {
      this.switchToProject = project;
      this.closeProjectSwitchDialog();
      this.closeProject();
    }
  };

  beforeTabSwitch(tab:string,details:any){
    this.eventManager.emitOnTabswitch({tab,details})
  }
  showMoreProjects($event: any, count: number) {
    this.projectsVisibleCount = count;
  };

  switchStudioView($event: Event, view: 'design' | 'aira') {
    $event.preventDefault();

    const isAiraView = view === 'aira';
    if (this.isAiraMode === isAiraView) return;

    const navigate = () => {
      const path = isAiraView ? '/ai-studio' : '/page';
      this.router.navigate([path]).then((val) => {
        this.isAiraMode = isAiraView;
        if(!val) {
          this.isAiraMode = !isAiraView;
        }
      });
    };
    this.spinnerService.show('Saving..');
    this.wsManager.saveActiveWs.next(() => {
      this.spinnerService.hide();
      navigate();
    });
  }

  cleanPreview(): void {
    const projectId = this.projectService.getProjectId();
    const url = environment.SERVICES_BASE_PATH + `services/projects/${projectId}/resources/content/project/generated-rn-app`;

    this.wmHttpService.send({
      url: url,
      method: 'DELETE'
    }).then((response: any) => {
    }).catch((error: any) => {
    }).finally(() => {
      this.runProject();
    })
  }

  save(): Promise<any> {
    return this.pageWsService.saveActiveTabContent();
  }

  // onExportDropdownToggle(isOpen: boolean) {
  //   if (isOpen && this.dropdownProjectUpdates?.isOpen) {
  //     this.dropdownProjectUpdates.hide();
  //   }
  // }

  onProjectUpdatesDropdownToggle(isOpen: boolean) {
    if (isOpen && this.dropdownExport?.isOpen) {
      this.dropdownExport.hide();
    }
    if (isOpen && this.dropdown?.isOpen) {
      this.dropdown.hide();
    }
  }
}
